module.exports = __webpack_public_path__ + "static/media/card-blog14.ebc255ba.jpg";